module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-container"
  }, [_c('div', {
    staticClass: "recommend-container"
  }, [_c('van-cell', {
    attrs: {
      "title-class": "form-label",
      "is-link": "",
      "center": "",
      "title": "开启智能推荐"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "active-color": "#1677FF",
            "size": "24"
          },
          on: {
            "change": _vm.clear
          },
          model: {
            value: (_vm.isRecommend),
            callback: function($$v) {
              _vm.isRecommend = $$v
            },
            expression: "isRecommend"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.isRecommend) ? _c('div', {
    staticClass: "recommend-props-wrap"
  }, [_c('div', {
    staticClass: "van-cell",
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "van-cell__value template-category",
    staticStyle: {
      "flex": "2"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentSubCategory.dictValue))])]), _vm._v(" "), _c('i', {
    staticClass: "van-icon van-icon-arrow van-cell__right-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "van-cell"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "van-cell__value template-count",
    staticStyle: {
      "flex": "2"
    }
  }, [_c('van-radio-group', {
    attrs: {
      "direction": "horizontal"
    },
    on: {
      "change": function($event) {
        return _vm.handleSearchRecommend()
      }
    },
    model: {
      value: (_vm.templateCount),
      callback: function($$v) {
        _vm.templateCount = $$v
      },
      expression: "templateCount"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": 1
    }
  }, [_vm._v("16以下")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": 2
    }
  }, [_vm._v("17-29")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": 3
    }
  }, [_vm._v("30以上")])], 1)], 1)])]) : _vm._e()], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "info-box ",
      class: [_vm.selectIndex == index ? 'selected' : '', _vm.checkItemCanSelect(item) ? '' : 'no-select'],
      on: {
        "click": function($event) {
          return _vm.onSelectTech(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "top"
    }, [(_vm.handleCheckIsRecommend(item)) ? _c('div', {
      staticClass: "recommend_tip"
    }, [_vm._v("推荐")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tech-title",
      domProps: {
        "textContent": _vm._s(item.dictValue)
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "tech-desc",
      domProps: {
        "textContent": _vm._s(item.extraValue)
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      width: '98%',
      height: '40%'
    }),
    attrs: {
      "closeable": "",
      "close-icon": "close",
      "round": ""
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_c('span', [_vm._v("样本分类")])]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("样本类型")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row sample-wrapper"
  }, _vm._l((_vm.sampleCategories), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-grow-1"
    }, [_c('div', {
      class: ['radio-tag', _vm.currentCategory.dictKey == item.dictKey ? 'radio-tag__checked' : ''],
      on: {
        "click": function($event) {
          return _vm.handleSelectCategory(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.dictValue) + "\n        ")])])
  }), 0), _vm._v(" "), _vm._l((_vm.sampleCategories), function(category, k) {
    return _c('div', {
      key: k
    }, [(_vm.currentCategory && _vm.currentCategory.dictKey === category.dictKey) ? _c('div', [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.currentCategory.extraValue)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-row sample-wrapper"
    }, _vm._l((_vm.sampleSubCategories), function(item, index) {
      return (category.dictKey === item.parentId) ? _c('div', {
        key: index,
        staticClass: "flex-grow-1"
      }, [_c('div', {
        class: ['radio-tag', _vm.currentSubCategory.dictKey == item.dictKey ? 'radio-tag__checked' : ''],
        on: {
          "click": function($event) {
            return _vm.handleSubSelectCategory(item)
          }
        }
      }, [_vm._v("\n              " + _vm._s(item.dictValue) + "\n            ")])]) : _vm._e()
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "pop-button-wrap"
  }, [_c('div', {
    staticClass: "pop-button",
    on: {
      "click": function($event) {
        return _vm.handleSearchRecommend()
      }
    }
  }, [_c('span', [_vm._v("确定")])])])], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "van-cell__title form-label form--required",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('span', [_vm._v("样本分类")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "van-cell__title form-label form--required",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('span', [_vm._v("样本数量")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49bdbc22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Proteomics/components/QuantitativeTech.vue
// module id = 1622
// module chunks = 8